import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { MiscLayout, PrimaryLayout } from '../Layouts';
import notify from 'devextreme/ui/notify';


function MiscTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const colorOptions = [
        { id: '1', name: 'Aqua' },
        { id: '2', name: 'Blue' },
        { id: '3', name: 'Fuchsia' },
        { id: '4', name: 'Green' },
        { id: '5', name: 'Lime' },
        { id: '6', name: 'Maroon' },
        { id: '7', name: 'Navy' },
        { id: '8', name: 'Olive' },
        { id: '9', name: 'Purple' },
        { id: '0', name: 'Red' },
        { id: 'S', name: 'Silver' },
        { id: 'T', name: 'Teal' },
        { id: 'W', name: 'White' },
        { id: 'Y', name: 'Yellow' },
        { id: 'Z', name: 'Window' }
    ];
    const handleFieldChange = useCallback(() => {
    }, []);
    const handleSelectionChange = useCallback(() => {
    }, []);
    const handleprimaryFormLoad = useCallback(() => {


        loadLookupFromStaticData(formRefs, "CREDITCOLOR", colorOptions);
        loadLookupFromStaticData(formRefs, "AUTOAPPLYSPLITDEPOSIT", [{ id: 'N', name: "No" }, { id: 'Y', name: "Yes" }]);
        loadLookupFromStaticData(formRefs, "PRECOMMITSECURITY", [{ id: 'Y', name: "Yes, allow access to accounts options" }, { id: 'N', name: "No, do not allow access to accounts options" }]);
        loadLookupFromStaticData(formRefs, "UPDATEITEMSTATUS", [{ id: 'A', name: "No, do not update Status" }, { id: 'B', name: "Yes, update Lot Status to Inactive if quantities are all 0 after commit" }]);
        loadLookupFromStaticData(formRefs, "TRANSFERTRANSNOTOFB", [{ id: 'N', name: "No, do not transfer trans# to FB/DO" }, { id: 'Y', name: "Yes, transfer trans# to FB/DO" }]);
        loadLookupFromStaticData(formRefs, "SHOWCHECKDIFFDIALOG", [{ id: 'Y', name: "Yes, display check diff. dialog" }, { id: 'N', name: "No, automatically update quantity" }]);
        setColor();
    }, []);

    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if (props.formFields[name])
                formRefs.current[name].instance().option('value', props.formFields[name]);
        }

    };
    const setColor = () => {
        const textboxRef = formRefs.current['edtColor'];
        const selectedColor = colorOptions.find(c => c.id === props.formFields.CREDITCOLOR);

        if (textboxRef?.instance && selectedColor) {
            const element = textboxRef.instance().element(); // DevExtreme wrapper
            const inputElement = element.querySelector('.dx-texteditor-input');

            if (inputElement) {
                inputElement.style.backgroundColor = selectedColor.name;
            }
        }
    }
    useEffect(() => {
        setColor();
    }, [props.formFields.CREDITCOLOR]);
    return (
        <div style={{ marginTop: "10px" }}>
            <FormField
                currrentUser={currentUser}
                layoutId='2EEBBFF4-4BC2-43F2-BE6A-97600B0D85AE'
                layoutName='WMPrimarySetupForm'
                defaultFormSchema={MiscLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleprimaryFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(MiscTab);
